import React from "react";
import { TooltipArrow } from "../../../components/ui/tooltips";
import {
  formatDashboardCount,
  formatDashboardHours,
} from "../../../utils/timekeeping";

/**
 * Compact primary-project pill with a hover breakdown of week project totals.
 *
 * @param {Object} props - Component props.
 * @param {Object|null} [props.primaryProject] - Most common job for the week.
 * @param {Array<Object>} [props.projects=[]] - All jobs with week totals.
 * @returns {JSX.Element} Primary project chip cell content.
 */
const PrimaryJobChip = ({ primaryProject = null, projects = [] }) => {
  if (!primaryProject) {
    return <span className="text-gray-400">-</span>;
  }

  const breakdown = (
    <div className="w-[300px] py-1 text-left text-xs text-gray-900">
      <div className="grid grid-cols-[minmax(0,1fr)_2.5rem_2.75rem_2.75rem] gap-x-2 gap-y-1 items-end">
        <div className="font-semibold text-gray-500">Project</div>
        <div className="text-right font-semibold leading-tight text-gray-500">
          Shifts
        </div>
        <div className="text-right font-semibold leading-tight text-gray-500">
          Worker
          <br />
          Hours
        </div>
        <div className="text-right font-semibold leading-tight text-gray-500">
          Payout
          <br />
          Hours
        </div>
        {projects.map((project) => (
          <React.Fragment key={project.id}>
            <div className="min-w-0 truncate text-gray-900">
              {project.number}
              {project.description ? (
                <span className="text-gray-600"> - {project.description}</span>
              ) : null}
            </div>
            <div className="text-right tabular-nums text-gray-700">
              {formatDashboardCount(project.shiftCount)}
            </div>
            <div className="text-right tabular-nums text-gray-700">
              {formatDashboardHours(project.workerHours)}
            </div>
            <div className="text-right tabular-nums text-gray-700">
              {formatDashboardHours(project.payoutHours)}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  return (
    <span
      className="relative inline-flex"
      onClick={(event) => event.stopPropagation()}
    >
      <span className="inline-flex min-w-12 justify-center rounded-full border border-gray-200 bg-gray-100 px-2 py-0.5 text-[11px] font-normal text-gray-800">
        {primaryProject.number || "-"}
      </span>
      <TooltipArrow
        text={breakdown}
        position="below"
        align="end"
        usePortal
        closeDelay={0}
        className="!pointer-events-none !whitespace-normal !bg-white !text-left shadow-md shadow-gray-400/40"
      />
    </span>
  );
};

export default PrimaryJobChip;
